import React from 'react';
import { BlockContent } from './block-content';
import styles from './custom-block-content.module.scss';
import clsx from 'clsx';

export function BlockContentColumns({ node: { column1, column2, column3, layout } }) {
  const layoutStyle = `columns_${layout ? layout : 3}`;

  return (
    <div className={clsx(styles.container, styles[layoutStyle])}>
      {Array.isArray(column1) && (
        <BlockContent blocks={column1.map((block, idx) => (idx === 0 ? { ...block, first: true } : block))} />
      )}
      {Array.isArray(column2) && (
        <BlockContent blocks={column2.map((block, idx) => (idx === 0 ? { ...block, first: true } : block))} />
      )}
      {Array.isArray(column3) && (
        <BlockContent blocks={column3.map((block, idx) => (idx === 0 ? { ...block, first: true } : block))} />
      )}
    </div>
  );
}
